import { Button, Form } from "reactstrap";
import Modal from "react-bootstrap/Modal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faSave, faTimes } from "@fortawesome/free-solid-svg-icons";
import { PulseLoader } from "react-spinners";

export default function ModalFormTp({
  show,
  onHide,
  editTpId,
  formTp,
  handleChangeFormTp,
  handleSubmitTp,
  isSubmittingTp,
}) {
  return (
    <Modal
      show={show}
      onHide={onHide}
      size="lg"
      aria-labelledby="modal-tp"
      centered
      backdrop="static"
      keyboard={false}
    >
      <div className="d-flex header-modal">
        <h5>{editTpId ? "Update TP" : "Buat TP"}</h5>

        <div className="ml-auto x-close">
          <FontAwesomeIcon icon={faTimes} onClick={onHide} />
        </div>
      </div>

      <hr />

      <Modal.Body className="modal-body">
        <Form onSubmit={handleSubmitTp}>
          <div className="row">
            <div className="col-md-6 mb-3">
              <label style={{ fontWeight: 600, color: "#374151" }}>TP</label>
              <input
                type="text"
                name="tp"
                className="form-control"
                placeholder="Masukkan TP"
                value={formTp.tp}
                onChange={handleChangeFormTp}
                disabled={isSubmittingTp}
                autoFocus
                style={{
                  borderRadius: 10,
                  border: "1px solid #d1d5db",
                  padding: "10px 12px",
                }}
              />
            </div>

            <div className="col-md-6 mb-3">
              <label style={{ fontWeight: 600, color: "#374151" }}>
                Keterangan
              </label>
              <input
                type="text"
                name="keterangan"
                className="form-control"
                placeholder="Masukkan keterangan"
                value={formTp.keterangan}
                onChange={handleChangeFormTp}
                disabled={isSubmittingTp}
                style={{
                  borderRadius: 10,
                  border: "1px solid #d1d5db",
                  padding: "10px 12px",
                }}
              />
            </div>

            <div className="col-md-6 mb-3">
              <label style={{ fontWeight: 600, color: "#374151" }}>
                Pengujian
              </label>
              <select
                name="pengujian"
                className="form-control"
                value={formTp.pengujian}
                onChange={handleChangeFormTp}
                disabled={isSubmittingTp}
                style={{
                  borderRadius: 10,
                  border: "1px solid #d1d5db",
                  padding: "10px 12px",
                }}
              >
                <option value="">Pilih Pengujian</option>
                <option value="Semester 1">Semester 1</option>
                <option value="Semester 2">Semester 2</option>
              </select>
            </div>

            {formTp.pengujian === "Semester 1" && (
              <div className="col-md-6 mb-3">
                <label style={{ fontWeight: 600, color: "#374151" }}>
                  Deskripsi Rapor Semester 1
                </label>
                <textarea
                  name="deskripsi_rapor_semester_1"
                  className="form-control"
                  placeholder="Masukkan deskripsi rapor semester 1"
                  value={formTp.deskripsi_rapor_semester_1}
                  onChange={handleChangeFormTp}
                  rows={3}
                  style={{
                    borderRadius: 10,
                    border: "1px solid #d1d5db",
                    padding: "10px 12px",
                    resize: "vertical",
                  }}
                />
              </div>
            )}

            {formTp.pengujian === "Semester 2" && (
              <div className="col-md-6 mb-3">
                <label style={{ fontWeight: 600, color: "#374151" }}>
                  Deskripsi Rapor Semester 2
                </label>
                <textarea
                  name="deskripsi_rapor_semester_2"
                  className="form-control"
                  placeholder="Masukkan deskripsi rapor semester 2"
                  value={formTp.deskripsi_rapor_semester_2}
                  onChange={handleChangeFormTp}
                  rows={3}
                  style={{
                    borderRadius: 10,
                    border: "1px solid #d1d5db",
                    padding: "10px 12px",
                    resize: "vertical",
                  }}
                />
              </div>
            )}
          </div>

          <div className="d-flex" style={{ gap: 10, justifyContent: "flex-end" }}>
            <Button
              type="button"
              className="btn btn-light"
              onClick={onHide}
              disabled={isSubmittingTp}
              style={{
                borderRadius: 10,
                fontWeight: 600,
                padding: "8px 14px",
              }}
            >
              Batal
            </Button>

            <Button
              className="btn-modal-create"
              type="submit"
              disabled={isSubmittingTp}
              style={{
                borderRadius: 12,
                padding: "8px 14px",
                boxShadow: "0 10px 24px rgba(108,99,255,0.18)",
                fontWeight: 600,
              }}
            >

              {isSubmittingTp ? (
                <>
                  <i className="fa fa-spinner fa-spin mr-2" />
                  Menyimpan...
                </>
              ) : (
                <>
                  <FontAwesomeIcon icon={editTpId ? faSave : faPlus} />{" "}
                  {editTpId ? "Perbarui" : "Tambahkan"}
                </>
              )}
            </Button>
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  );
}